import {REST_PILOT_URL} from "../common/constants";
import ExpandableROList from "../common/ExpandableROList";
import {PilotRO} from "./PilotRO";
import {sortPilots} from "./PilotUtils";

const PilotROList = ExpandableROList(PilotRO, REST_PILOT_URL, "pilot",
    "Seznam pilotů", sortPilots, null, f=>f, true);

export default PilotROList;